export default __webpack_public_path__ + "static/logo-d517829d0de0144d478bd06036bb3f72.png";